<template>
	<video autoPlay loop muted playsInline :key="webm">
		<!-- We use our video tag to only show desktop videos for desktop and mobile videos for mobile -->
		<source type="video/webm" :src="webm" />
		<source type="video/mp4" :src="mp4" />
	</video>
</template>

<script>
export default {
	props: {
		webmSrc: {
			type: Object,
			default: () => ({})
		},
		mp4Src: {
			type: Object,
			default: () => ({})
		}
	},
	computed: {
		webm() {
			return this.windowSize.width < 768 ? this.webmSrc.mobile : this.webmSrc.desktop;
		},
		mp4() {
			return this.windowSize.width < 768 ? this.mp4Src.mobile : this.mp4Src.desktop;
		}
	}
};
</script>

<style lang="scss" scoped>
video {
	width: 100%;
	height: 100%;
	object-fit: cover;
}
</style>
